/* export const environment = {
  production: true,
  apiUrl: process.env['NG_APP_API_AUTH_URL'] || 'https://pegaespumasf.onrender.com/api',
  emailjs: {
    serviceID: process.env['NG_APP_SERVICE_ID'] || '',
    templateID: process.env['NG_APP_TEMPLATE_ID'] || '',
    publicKey: process.env['NG_APP_PUBLIC_KEY'] || '',
  },
}; */

export const environment = {
  production: true,
  apiUrl: 'https://pegaespumasf.onrender.com',
  emailjs: {
    serviceID: 'service_ai8b2ab', // Reemplaza con tus valores reales
    templateID: 'template_ffwympx',
    publicKey: '63gs8l3zZV821iM_G',
  },
};
